module.exports = __webpack_public_path__ + "static/media/two_women_faces.87103a6e.svg";